import { useSyncExternalStore } from "react";
import type { ExamId, Question } from "../types";

/**
 * Ngân hàng đề lúc chạy. Nội dung KHÔNG nằm trong bản build: backend trả về sau khi đăng nhập
 * (khách chỉ nhận bộ câu công khai). Mảng/Map được cập nhật tại chỗ để mọi nơi import vẫn dùng chung.
 */
export const ALL_QUESTIONS: Question[] = [];
const byId = new Map<string, Question>();
export const QUESTION_BY_ID: ReadonlyMap<string, Question> = byId;

export interface BankStats { total: number; byExam: Partial<Record<ExamId, number>> }
let stats: BankStats = { total: 0, byExam: {} };
let version = 0;
const listeners = new Set<() => void>();

export function questionsForExam(exam: ExamId): Question[] {
  return ALL_QUESTIONS.filter((q) => q.exam === exam);
}

function countStats(qs: readonly Question[]): BankStats {
  const byExam: Partial<Record<ExamId, number>> = {};
  for (const q of qs) byExam[q.exam] = (byExam[q.exam] ?? 0) + 1;
  return { total: qs.length, byExam };
}

/** Nạp (thay thế) ngân hàng đề. `full` = số câu của toàn ngân hàng (khi chỉ nạp bộ công khai). */
export function loadBank(qs: readonly Question[], full?: BankStats): void {
  ALL_QUESTIONS.length = 0;
  ALL_QUESTIONS.push(...qs);
  byId.clear();
  for (const q of qs) byId.set(q.id, q);
  stats = full ?? countStats(qs);
  version++;
  for (const l of listeners) l();
}

/** Tổng số câu của ngân hàng đầy đủ (kể cả khi khách chỉ thấy bộ công khai). */
export function bankStats(): BankStats {
  return stats;
}

export function subscribeBank(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function useBankVersion(): number {
  return useSyncExternalStore(subscribeBank, () => version, () => version);
}
